module.exports = __webpack_public_path__ + "img/tip-top.26ddb432.png";